import { getPublicWebsiteUrl } from "@/lib/websiteUrls"

const PUBLIC_WEBSITE_URL = getPublicWebsiteUrl()
const TYPEFORM_URL = "https://soenergy.typeform.com"
const WHAT_3_WORDS_URL = "https://what3words.com"
const TRUSTPILOT_URL = "https://uk.trustpilot.com"
const HOMETREE_URL =
  "https://www.hometree.co.uk/products/so-energy-rewards/?&utm_medium=partnerships&utm_source=soenergy&utm_campaign=soenergyrewards"
const HOMETREE_BOILER_SERVICE_URL =
  "https://www.hometree.co.uk/products/so-energy-asv-care-plans/?utm_medium=partnerships&utm_source=soenergy&utm_campaign=websiteasvonly"
const JUSTSOYOUKNOW_URL = "https://justsoyouknow.so.energy"

const helpRoutes = {
  getSupport: `${PUBLIC_WEBSITE_URL}support/home`,
  energySaving: `${PUBLIC_WEBSITE_URL}energy/saving`,
  unhappy: `${PUBLIC_WEBSITE_URL}help/unhappy`,
  emergency: `${PUBLIC_WEBSITE_URL}help/emergency`,
  priceCap: `${PUBLIC_WEBSITE_URL}energy/price-cap`,
  troubleshooting: `${PUBLIC_WEBSITE_URL}troubleshooting-ihd`,
  contactUs: `/myaccount/contact-us`,
  supportArticlePSR: `${PUBLIC_WEBSITE_URL}support/solutions/articles/7000023268-priority-services-register-psr-`,
  switchingProcessSupportArticle: `${PUBLIC_WEBSITE_URL}support/solutions/articles/7000046444-the-switching-process`,
  wrongOMRSupportArticle: `${PUBLIC_WEBSITE_URL}support/solutions/articles/7000046447-my-opening-reading-is-wrong`,
  soChargedFullFaqs: `${JUSTSOYOUKNOW_URL}/posts/2126587-`,
  seasonalPayments: `${JUSTSOYOUKNOW_URL}/posts/2110475`,
  justSoYouKnow: `${JUSTSOYOUKNOW_URL}`,
} as const

// https://soenergy.typeform.com/to/x0IIpzIo

const productRoutes = {
  solar: `${PUBLIC_WEBSITE_URL}solar/quote`,
  homeCover: `${PUBLIC_WEBSITE_URL}heating/so-home-cover`,
  evChargers: `${PUBLIC_WEBSITE_URL}ev/ev-chargers`,
  evChargerOffer: `${PUBLIC_WEBSITE_URL}go/ev-chargers`,
  smartMeters: `${PUBLIC_WEBSITE_URL}energy/smart-meters`,
  allProducts: `${PUBLIC_WEBSITE_URL}products/all-products`,
  evHomeCharging: `${PUBLIC_WEBSITE_URL}ev/ev-home-charging`,
  heatPumpsOffer: `${PUBLIC_WEBSITE_URL}go/so-heat-pumps?utm_medium=partnerships&utm_source=soenergy&utm_campaign=soenergyrewards`,
} as const

const aboutUsRouters = {
  aboutUs: `${PUBLIC_WEBSITE_URL}about-us`,
  reviews: `${PUBLIC_WEBSITE_URL}about-us/reviews`,
  news: `${PUBLIC_WEBSITE_URL}news`,
  careers: `https://careers.so.energy`,
  ourEnergy: `${PUBLIC_WEBSITE_URL}our-energy`,
} as const

export const ExternalRoute = {
  // LEGACY WEBSITE URLS
  billsAndTransactions: `/myaccount/balance`,
  referAFriend: `/myaccount/refer`,
  payments: `/myaccount/payments`,
  meterReadings: `/myaccount/readings`,
  meterReadingHistory: `/myaccount/meter-reading-history`,
  personalDetails: `/myaccount/personal-details`,
  energyVote: `/myaccount/energy-vote`,
  renewal: `/myaccount/renew`,
  progress: `/myaccount/progress`,
  movingHome: `/myaccount/move-out`,
  moveOutStatus: `/myaccount/move-out/status`,

  websiteHome: `${PUBLIC_WEBSITE_URL}`,
  movingInTypeform: `${PUBLIC_WEBSITE_URL}moving-in`,
  moveWithUsTypeform: `${TYPEFORM_URL}/to/zbVfKHMM`,
  contact: `${PUBLIC_WEBSITE_URL}contact`,
  privacyPolicy: `${PUBLIC_WEBSITE_URL}privacy`,
  termsAndConditions: `${PUBLIC_WEBSITE_URL}terms`,
  cookiePolicy: `${PUBLIC_WEBSITE_URL}cookies`,
  warmHomeDiscount: `${PUBLIC_WEBSITE_URL}warm-home-discount`,
  smartMeterBooking: `${PUBLIC_WEBSITE_URL}smart-meter-booking`,
  smartMeterBookingInstall: `${PUBLIC_WEBSITE_URL}smart-meter-booking/install`,
  evChargerQuoteSurvey: `${TYPEFORM_URL}/evcharger`,
  what3Words: `${WHAT_3_WORDS_URL}`,
  soUniqueQuoteSurvey: `${TRUSTPILOT_URL}/evaluate/so.energy`,
  prizeDrawTerms: `${PUBLIC_WEBSITE_URL}so-rewarding-terms-and-conditions-2026`,
  referAFriendTerms: `${PUBLIC_WEBSITE_URL}refer-terms`,
  hometree: `${HOMETREE_URL}`,
  hometreeBoilerService: `${HOMETREE_BOILER_SERVICE_URL}`,
  hometreeRenewalOffer: `${TYPEFORM_URL}/to/omIygi2J`,
  ...aboutUsRouters,
  ...productRoutes,
  ...helpRoutes,
} as const

export type ExternalRoute = (typeof ExternalRoute)[keyof typeof ExternalRoute]
